<template>
  <div
    class="mt6 ce-productDetails-competitorProducts"
    v-if="hasAccess && hasResults">
    <h2 class="ce-productDetailsHeadline">
      {{ $t('competitorApp.internalProductPage.headline') }}
    </h2>

    <div class="ce-productDataTable ce-competitorProductsTable">
      <table>
        <tbody>
          <tr>
            <th>{{ $t('competitorApp.internalProductPage.tableHeader.productName') }}</th>
            <th>{{ $t('competitorApp.internalProductPage.tableHeader.competitor') }}</th>
            <th />
          </tr>
          <competitor-product
            v-for="(hit, index) in competitorProductResults.hits"
            :style="(index + 1) % 2 ? 'background: ' + tableBgColor : ''"
            :key="hit.id"
            :product="hit"
          />
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import CompetitorAppService from 'services/CompetitorAppService';
import CompetitorProduct from './CompetitorProduct.vue';

export default {
  props: {
    tableBgColor: {
      type: String,
      required: false,
      default: '#ebebeb'
    }
  },
  components: { CompetitorProduct },
  data() {
    return {
      competitorProductResults: null
    };
  },
  computed: {
    ...mapState(['pigment', 'activeIndustry']),
    ...mapState('user', ['activeUser']),
    ...mapGetters('user', ['canViewCompetitorApp', 'token']),
    hasAccess() {
      return this.activeUser
          && this.canViewCompetitorApp;
    },
    hasResults() {
      return this.competitorProductResults
        && this.competitorProductResults.hits
        && Array.isArray(this.competitorProductResults.hits)
        && this.competitorProductResults.hits.length > 0;
    }
  },
  mounted() {
    if (this.hasAccess) {
      this.fetchCompetitorData();
    }
  },
  watch: {
    // Reset and re-fetch competitor data on industry change
    activeIndustry() {
      this.competitorProductResults = null;
      if (this.hasAccess) {
        this.fetchCompetitorData();
      }
    }
  },
  methods: {
    async fetchCompetitorData() {
      this.competitorProductResults = await CompetitorAppService.productsByInternalProduct(this.pigment.prd, this.activeIndustry, this.token);
    }
  }
};
</script>

<style lang="less">
.ce-productDetails-competitorProducts {
  .ce-competitorProductsTable {
    overflow: auto;
  }
}
</style>
